export default __webpack_public_path__ + "static/media/hht2_ep19_speaking_04.c9982650.png";